import styles from "./IconPackSelector.module.css";
import { FaSmile, FaRegSmile } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

interface IconPackSelectorProps {
  value: "solid" | "regular";
  onChange: (val: "solid" | "regular") => void;
  label?: string;
  error?: string;
  touched?: boolean;
}

export default function IconPackSelector({
  value,
  onChange,
  label,
  error,
  touched,
}: IconPackSelectorProps) {
  const { t } = useLanguage();

  const iconPacks = [
    { id: "solid", label: t("solid"), icon: <FaSmile /> },
    { id: "regular", label: t("regular"), icon: <FaRegSmile /> },
  ];

  return (
    <div className={styles.wrapper}>
      <span className={styles.title}>{label || t("iconStyle")}</span>

      <div className={styles.selector}>
        {iconPacks.map((pack) => (
          <div
            key={pack.id}
            className={`${styles.option} ${value === pack.id ? styles.active : ""}`}
            onClick={() => onChange(pack.id as "solid" | "regular")}
          >
            <div className={styles.iconPreview}>{pack.icon}</div>
            <span className={styles.label}>{pack.label}</span>
          </div>
        ))}
      </div>

      {touched && error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
